import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PopupMenu from '../../PopupMenu';
import { TypeIcon } from '../styles';

const ChunkContentEditorFooter = ({ type, setType, loading = false, updating = false }) => {
  const isUpdating = loading || updating;

  const [showTypeSelector, setShowTypeSelector] = useState(false);

  const getArticleTypeIcon = (articleType) => `/assets/images/theme-2/icons/${articleType}.svg`;

  const selectType = () => {
    setShowTypeSelector(!showTypeSelector);
  };

  const menuOptions = ['chunk', 'video', 'link'].map((articleType) => ({
    name: i18n.__(`chunk_type_${articleType}`),
    src: getArticleTypeIcon(articleType),
    tag: articleType,
    onSelect: (selectedType) => {
      if (!isUpdating && type !== selectedType) {
        setType(selectedType);
      }
      setShowTypeSelector(false);
    },
  }));

  const menuPopup = (
    <PopupMenu
      id="articleTypesPopup"
      popupIsOpen={showTypeSelector}
      onClose={() => setShowTypeSelector(false)}
      options={menuOptions}
    />
  );

  return (
    <>
      <TypeIcon
        src={getArticleTypeIcon(type)}
        title={i18n.__('select_symbol')}
        onClick={selectType}
        disabled={loading}
        id="articleTypesPopup"
      >
        {i18n.__('select_symbol')}
      </TypeIcon>
      {menuPopup}
    </>
  );
};

export default ChunkContentEditorFooter;

ChunkContentEditorFooter.propTypes = {
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  updating: PropTypes.bool,
};
